module.exports = __webpack_public_path__ + "static/media/flightdelayclaim.ead320d1.svg";